import axios from 'axios'

const REGISTRATION_API = '/OktaSpaRegistration/api'
let url = window.location.href
let OktaUserApi = ''
let spaUrl = ''
let OktaUserProfile = ''
let EnvArray = [];
let elements = ''
let appUrl = ''

axios.defaults.withCredentials = true;
axios.defaults.timeout = 30000;

function getEnviromentValues() {
  if (url.indexOf("spa-okta-registration-itg") != -1 || url.indexOf("localhost") != -1) {
    OktaUserApi = process.env.VUE_APP_ITG_OktaUserAPi
    spaUrl = process.env.VUE_APP_ITG_SpaUrl
    OktaUserProfile = process.env.VUE_APP_ITG_OktaUserProfile
    appUrl = process.env.VUE_APP_ITG_AppUrl
    elements = {OktaUserApi: OktaUserApi, spaUrl: spaUrl, OktaUserProfile: OktaUserProfile, appUrl: appUrl};
    EnvArray.push(elements)
    return EnvArray
  } else if (url.indexOf("spa-okta-registration-cat") != -1) {
    OktaUserApi = process.env.VUE_APP_CAT_OktaUserAPi
    spaUrl = process.env.VUE_APP_CAT_SpaUrl
    OktaUserProfile = process.env.VUE_APP_CAT_OktaUserProfile
    appUrl = process.env.VUE_APP_CAT_AppUrl
    elements = {OktaUserApi: OktaUserApi, spaUrl: spaUrl, OktaUserProfile: OktaUserProfile, appUrl: appUrl};
    EnvArray.push(elements)
    return EnvArray
  } else {
    OktaUserApi = process.env.VUE_APP_PROD_OktaUserAPi
    spaUrl = process.env.VUE_APP_PROD_SpaUrl
    OktaUserProfile = process.env.VUE_APP_PROD_OktaUserProfile
    appUrl = process.env.VUE_APP_PROD_AppUrl
    elements = {OktaUserApi: OktaUserApi, spaUrl: spaUrl, OktaUserProfile: OktaUserProfile, appUrl: appUrl};
    EnvArray.push(elements)
    return EnvArray
  }
}

export async function lookupProducer(producerNum) {
  return axios.post(`${REGISTRATION_API}/lookup/producer`, {"producerNumber": producerNum})
}

export async function validateProducer(param) {
  return axios.post(`${REGISTRATION_API}/validate/producer`, param)
}

export async function lookupUser(login) {
  return axios.post(`${REGISTRATION_API}/lookup/user`, {"login": login})
}

export async function registerProducer(data) {
  let param = ''
  if (data.producerAssistantId === '') {
    param = {
      "firstName": data.firstname,
      "lastName": data.lastname,
      "email": data.email,
      "login": data.login,
      "password": data.password,
      "securityQuestion": {
        "question": data.securityQuestion.question,
        "answer": data.securityQuestion.answer
      }
    }
  } else {
    param = {
      "firstName": data.firstname,
      "lastName": data.lastname,
      "email": data.email,
      "login": data.login,
      "password": data.password,
      "securityQuestion": {
        "question": data.securityQuestion.question,
        "answer": data.securityQuestion.answer
      }
    }
  }
  return axios.post(`${REGISTRATION_API}/register`, param).catch((error) => {
    return {
      response: error.response, status: error.status, message: error.message,
      code: error.code, request: error.request, statusText: error.statusText, headers: error.headers }
    });
}

export async function changePassword(data) {
  const request = {
    "password": data.password,
    "securityQuestion": {
      "question": data.securityQuestion.question,
      "answer": data.securityQuestion.answer
    }
  }
  return axios.post(`${REGISTRATION_API}/update/migrateaccount`, request)
}

export async function registerSecondProducer(data) {
  let request=''
  if(data.partyTypeCode=='C'){
    request = {
      "producerNumber": data.producerNumber,
      "taxId": data.dobOrTaxId
    }
  }else{
    request = {
      "producerNumber": data.producerNumber,
      "dateOfBirth": data.dobOrTaxId
    }
  }
  return axios.post(`${REGISTRATION_API}/update/addproducernumber`, request)
}

export async function addProducerAssistant(data) {
  const request = {
    "registrationKey": data.registrationKey,
    "dateOfBirth": data.dob,
  }
  return axios.post(`${REGISTRATION_API}/update/addproducerassistant`, request)
}

export async function getUserOktaUserId() {
  let values = getEnviromentValues()
  return axios.get(`${values[0]['OktaUserApi']}`, {withCredentials: true})
}

export async function getUserProfile() {
  let values = getEnviromentValues()
  return axios.get(`${values[0]['OktaUserProfile']}`, {withCredentials: true})
}

export async function lookupSignUrl() {
  let values = getEnviromentValues()
  return values[0]['spaUrl']
}

export async function lookupAppUrl() {
  let values = getEnviromentValues()
  return values[0]['appUrl']
}
